import React, { useEffect } from 'react'
import { DispatchProp, connect } from 'react-redux';
import { redirectSafe } from 'Utils/redux/actions';
import { redirect } from 'Utils/helpers/routerHelper';
import LoadingPage from './LoadingPage';

const Redirect: React.FunctionComponent<{to: string} & DispatchProp> = ({ to, dispatch }) => {
    useEffect(() => {
        // dispatch(redirectSafe(to))
        redirect(to)
    }, [])
    
    return <LoadingPage />
}

export default connect()(Redirect)
